import { Box, Stack, Text } from '@chaser/components';
import RouterButton from '../RouterButton';

const AccessDenied = () => (
  <Box p="large" style={{ textAlign: 'center', marginTop: '100px' }}>
    <Stack gap="large" alignItems="center">
      <Stack gap="medium" alignItems="center">
        <Text fontSize="medium" color="Mid Neutral 1">
          You don't have access to this page.
        </Text>
      </Stack>
      <RouterButton to="/" appearance="primary">
        Return to Dashboard
      </RouterButton>
    </Stack>
  </Box>
);

export default AccessDenied;
